import { lazy } from 'react';

export const CreateAnnouncementPageLazy = lazy(() => import('./CreateAnnouncementPage'));
